import { type BaseContext } from '@atlassian/state-machine/types';

import { type TimeoutEvent } from '../../network-state-machine-events.ts';

export function timeoutAsync<T extends BaseContext>(
  timeoutMs: number,
  eventType: TimeoutEvent['type'] = 'timeout',
) {
  return async (ctx: T, signal: AbortSignal): Promise<TimeoutEvent> => {
    await new Promise((resolve) => {
      const timeout = setTimeout(resolve, timeoutMs);

      signal.addEventListener('abort', () => {
        clearTimeout(timeout);
      });
    });

    return {
      type: eventType,
      error: new Error('Connection timeout'),
    };
  };
}
